import React, {useCallback, useState} from 'react';
import {
    Button,
    FormControl,
    Link,
    Stack,
} from '@mui/material';
import {Page} from '../../components/page/Page';
import {KeyOperationPanel} from "./KeyOperationPanel";
import {NavLink} from "react-router-dom";
import {AppPages, usePageUrl} from "../../app-layout/AppPages";
import {KeySnapshot} from "../../api/Model";
import {KeySelect} from "../../components/key-select/KeySelect";

export function KeyOperationsPage() {
    const [keySnapshot, setKeySnapshot] = useState<KeySnapshot | undefined>();
    const pageUrl = usePageUrl();

    const handleKeyOperationFinish = useCallback(() => {
        setKeySnapshot(undefined);
    }, [setKeySnapshot]);

    return (
        <Page
            header="Key Operations"
            description={
                <p>
                    Issue, collect, and move keys.
                    <br/>
                    The deprecated pages for <Link component={NavLink} to={pageUrl(AppPages.issueKey)} color="warning">
                        issue
                    </Link>, <Link component={NavLink} to={pageUrl(AppPages.returnKey)} color="warning">
                        collect
                    </Link>, and <Link component={NavLink} to={pageUrl(AppPages.moveKeys)} color="warning">
                        move
                    </Link>, keys are still available but will eventually be removed.
                </p>
            }
        >
            <Stack direction="row" gap={1} alignItems="center">
                <FormControl sx={{minWidth: 520, my: 2}} required fullWidth>
                    <KeySelect
                        label="Key Number"
                        keySnapshot={keySnapshot}
                        setKeySnapshot={setKeySnapshot}
                        required
                        variant="outlined"
                        placeholder="Select a key, or use the key reader to identify a key"
                    />
                </FormControl>
                {keySnapshot && (
                    <Button
                        variant="outlined"
                        sx={{height: 56}}
                        onClick={() => setKeySnapshot(undefined)}
                    >
                        Cancel
                    </Button>
                )}
            </Stack>

            {keySnapshot && (
                <KeyOperationPanel keySnapshot={keySnapshot} onFinish={handleKeyOperationFinish}/>
            )}
        </Page>
    );
}
